import { render } from "./ManageUserModal.vue?vue&type=template&id=fade078e"
import script from "./ManageUserModal.vue?vue&type=script&lang=js"
export * from "./ManageUserModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__